const ps = {
  initEmbeddedFlow: function (selector, options = {}) {
    const button = document.querySelector(selector);
    if (!button) return;
    button.addEventListener('click', () => this.openIframe(options));
  },
  openIframe: function (options = {}) {
    const iframe = document.createElement('iframe');
    iframe.id = 'ps-embedded-iframe';
    iframe.allow = 'clipboard-write';
    iframe.src = this.buildUrl(options);
    iframe.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;border:none;z-index:9999;';
    document.body.appendChild(iframe);
    this.setupMessageListener(options);
  },
  buildUrl: function (options = {}) {
    const baseUrl = options.overrideUrl ? `${options.overrideUrl}/introduction` : 'https://embedded.petscreening.com/introduction';
    const params = new URLSearchParams(options.queryParams).toString();
    return `${baseUrl}?${params}`;
  },
  setupMessageListener: function (options = {}) {
    window.addEventListener('message', event => {
      const allowedOrigins = [options.overrideUrl, 'https://embedded.petscreening.com'];
      if (!allowedOrigins.includes(event.origin)) return;
      if (options.callbacks) {
        if (typeof options.callbacks[event.data.type] === 'function') {
          options.callbacks[event.data.type](event.data);
        }
        if (typeof options.callbacks[event.data] === 'function') {
          options.callbacks[event.data](event.data);
        }
      }
      if (event.data === 'close') this.closeIframe();
    });
  },
  closeIframe: function () {
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.remove();
    }
  }
};
let globalThis;
if (typeof window !== 'undefined') {
  globalThis = window;
} else if (typeof global !== 'undefined') {
  globalThis = global;
} else {
  globalThis = {};
}
globalThis.ps = ps;

export { ps };
